import InputAdornment from '@material-ui/core/InputAdornment';
import LanguageAdornment from './LanguageAdornment';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles } from './style/gstheme';
import PropTypes from 'prop-types';
import LockIcon from '@material-ui/icons/Lock';
import { isRTL } from './utils/utils';

const styles = Object.assign({}, globalStyles);

class BasicReadField extends React.PureComponent {

    render() {

        const { classes, margin, text, label, fullWidth, locked, dataTest, disabled, invalid,
            multiline, lang, rows, fontFamily, icon, helperText, ariaLabel } = this.props;
        const endIcon = icon ?
            icon
            :
            locked ?
                <LockIcon style={{ color: '#9e9e9e' }} />
                :
                null;
        const styleClass = locked ? classes.basicReadField : classes.inputLabel;
        const rtl = isRTL(lang);

        return (
            <TextField
                margin={margin}
                name="text"
                value={text}
                variant="outlined"
                label={label}
                multiline={multiline}
                minRows={rows}
                maxRows={rows}
                error={invalid}
                helperText={helperText}
                fullWidth={fullWidth}
                style={{
                    marginTop: '0px'
                }}
                InputProps={{
                    inputProps: {
                        "data-test": dataTest,
                        "aria-label": ariaLabel,
                        ...(disabled) && {
                            "style": {
                                backgroundColor: '#f0f0f0'
                            }
                        },
                        "style": {
                            ...(fontFamily) && { fontFamily }
                        },
                        ...(rtl) && { dir: "rtl" },
                        "lang": lang
                    },
                    className: styleClass,
                    classes: {
                        input: styleClass
                    },
                    readOnly: true,
                    startAdornment: lang ? (<LanguageAdornment lang={lang} />) : null,
                    ...(endIcon) && {
                        endAdornment: <InputAdornment position="end">
                            {endIcon}
                        </InputAdornment>
                    }
                }} />
        );
    }
}

BasicReadField.defaultProps = {
    margin: "dense",
    fullWidth: false,
    locked: false,
    multiline: false,
    disabled: false,
    invalid: false,
    rows: 3,
    lang: null
};

BasicReadField.propTypes = {
    dataTest: PropTypes.string,
    ariaLabel: PropTypes.string,
    fontFamily: PropTypes.string,
    disabled: PropTypes.bool,
    invalid: PropTypes.bool,
    endIcon: PropTypes.object,
    helperText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    lang: PropTypes.string,
    icon: PropTypes.object,
    rows: PropTypes.number,
    margin: PropTypes.oneOf(['normal', 'dense']),
    text: PropTypes.string.isRequired,
    multiline: PropTypes.bool,
    locked: PropTypes.bool,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(BasicReadField);